import React from 'react';
import {NavLink} from 'react-router-dom';
import logo from '../assets/images/blue-logo.png';
import '../assets/css/Footer.css';

function Footer() {
    return (
        <footer className="container">
            <div className="d-flex bd-highlight w-100">
                <div className="p-2 flex-fill bd-highlight">
                    <img src={logo} alt="Logo" className="footer-logo"/>
                </div>
                <div className="p-2 flex-fill bd-highlight">
                    <div className="d-flex bd-highlight w-100">
                        <div className="p-2 flex-fill bd-highlight">
                            <NavLink className="nav-link" to="/contact-us">Contact Us</NavLink>
                            <div className="footer-details">hello@volkslanka.com</div>
                            <div className="footer-details">+94 77 638 3868</div>
                        </div>
                        <div className="p-2 flex-fill bd-highlight">
                            <NavLink className="nav-link" to="/about-us">About Us</NavLink>
                            <NavLink className="nav-link" to="/delivery">Delivery</NavLink>
                        </div>
                        <div className="p-2 flex-fill bd-highlight">
                            <NavLink className="nav-link" to="/" target="_blank">Facebook</NavLink>
                            <NavLink className="nav-link" to="/" target="_blank">Instagram</NavLink>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer-rights">
                All rights reserved {new Date().getFullYear()} | Volkslanka | <NavLink
                to={{pathname: "https://www.eccelleroit.com/"}} target="_blank">Eccellero IT (Pvt) Ltd</NavLink>
            </div>
        </footer>
    );
}

export default Footer;